import { createAction, createAsyncAction } from 'typesafe-actions';

import { AlertConfig } from '../types';

import {
  CurrencyResolutionWarning,
  FetchSimulationCubeSuccessPayload,
  SimulationCubeFilters,
  SimulationRunEstimate,
  SimulationRunStatus,
} from './types';

export const setSelectedDate = createAction(
  'flCashConsumption/setSelectedDate',
)<string>();
export const setAlertConfig = createAction(
  'flCashConsumption/setAlertConfig',
)<AlertConfig>();
export const setSimulationProgress = createAction(
  'flCashConsumption/setSimulationProgress',
)<number | null>();
export const setSimulationRunStatus = createAction(
  'flCashConsumption/setSimulationRunStatus',
)<SimulationRunStatus>();
export const setSimulationRunEstimate = createAction(
  'flCashConsumption/setSimulationRunEstimate',
)<SimulationRunEstimate | null>();
export const setSimulationRunEstimating = createAction(
  'flCashConsumption/setSimulationRunEstimating',
)<boolean>();
export const setConfirmationModalOpen = createAction(
  'flCashConsumption/setConfirmationModalOpen',
)<boolean>();
export const setLastRequestPayload = createAction(
  'flCashConsumption/setLastRequestPayload',
)<SimulationCubeFilters | null>();
export const setSimulationRunStarting = createAction(
  'flCashConsumption/setSimulationRunStarting',
)<boolean>();
export const setSimulationDownloading = createAction(
  'flCashConsumption/setSimulationDownloading',
)<boolean>();
export const setOutputCurrencyResolving = createAction(
  'flCashConsumption/setOutputCurrencyResolving',
)<boolean>();
export const setOutputCurrencyId = createAction(
  'flCashConsumption/setOutputCurrencyId',
)<{
  outputCurrencyId: number;
  warningMessage?: string;
}>();
export const setOutputCurrencyResolution = createAction(
  'flCashConsumption/setOutputCurrencyResolution',
)<{
  outputCurrencyId: number;
  warnings: CurrencyResolutionWarning[];
}>();
export const clearRunState = createAction('flCashConsumption/clearRunState')();

export const fetchSimulationCube = createAsyncAction(
  'flCashConsumption/fetchSimulationCube/request',
  'flCashConsumption/fetchSimulationCube/success',
  'flCashConsumption/fetchSimulationCube/failure',
)<
  SimulationCubeFilters | undefined,
  FetchSimulationCubeSuccessPayload,
  undefined
>();
